import ProjectShowcase from "../components/project-file/project-showcase.component";
import "../css-files/project.css";
const ProjectPage = () => {
  return (
    <>
      <ProjectShowcase />
    </>
  );
};
export default ProjectPage;
